import Check from '@mui/icons-material/Check';
import { Grid, Typography } from '@mui/material';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import useTeceoStyles from '../../../../useTeceoStyles';
import { getColorByRole } from '../../../../utils/generics';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { ChatParticipant } from '../../types/chat.types';
import ChatAvatar from '../ChatAvatar/ChatAvatar';

const useStyles = makeStyles()(() => ({
  name: {
    maxWidth: 220,
  },
}));

interface ChatParticipantListItemProps {
  participant: ChatParticipant;
  isSelected: boolean;
  multiselect: boolean;
}

const ChatParticipantListItem = ({
  participant,
  isSelected,
  multiselect,
}: ChatParticipantListItemProps) => {
  const { classes, cx } = useStyles();
  const { classes: teceoClasses } = useTeceoStyles();
  const { isStore } = useApplicationContext();

  return (
    <Grid container spacing={1} wrap="nowrap" justifyContent="space-between" alignItems="center">
      <Grid>
        <ChatAvatar
          size={3.75}
          src={participant.logoUrl}
          title={participant.commercialName}
          backgroundColor={getColorByRole({
            transparentWhenHasSrc: false,
            withSrc: !!participant.logoUrl,
            userRole: isStore ? 'VENDEDOR' : 'COMPRADOR',
          })}
        />
      </Grid>
      <Grid size="grow">
        <Typography
          className={cx(teceoClasses.truncate, classes.name)}
          color={isSelected ? 'primary' : 'textPrimary'}
        >
          {participant.commercialName}
        </Typography>
        <Typography
          className={cx(teceoClasses.truncate, classes.name)}
          color="textSecondary"
          variant="body2"
        >
          {participant.companyName}
        </Typography>
      </Grid>
      {multiselect && <Grid>{isSelected && <Check color="primary" />}</Grid>}
    </Grid>
  );
};

export default memo(ChatParticipantListItem);
